import { actionCreator, dispatchAction } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import { futureStateGraphSelectionChanged } from './futureStateGraphSelectionActions';

export type FutureStateProposalsChangedPayload = { futureStateId: ArdoqId };

export const futureStateProposalsChanged =
  actionCreator<FutureStateProposalsChangedPayload>(
    '[futureStateProposals] proposals changed'
  );

/**
 * Group membership is list-only metadata that does not affect the rendered
 * diagram. This refetches claims + groups without re-rendering the diagram.
 */
export const futureStateClaimGroupsChanged =
  actionCreator<FutureStateProposalsChangedPayload>(
    '[futureStateProposals] claim groups changed'
  );

export const focusAndRefreshProposals = (
  futureStateId: ArdoqId,
  focusNodeId: ArdoqId | null
): void => {
  if (focusNodeId) {
    dispatchAction(futureStateGraphSelectionChanged(focusNodeId));
  }
  dispatchAction(futureStateProposalsChanged({ futureStateId }));
};

export const refreshClaimGroups = (futureStateId: ArdoqId): void => {
  dispatchAction(futureStateClaimGroupsChanged({ futureStateId }));
};
